import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "slot-wrapper" }
const _hoisted_2 = { class: "slot-time fw-bold" }
const _hoisted_3 = { class: "fw-medium" }
const _hoisted_4 = { class: "slot-desc flex-col" }
const _hoisted_5 = { class: "slot-price" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_si_currency = _resolveComponent("si-currency")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: _normalizeClass(["slot-btn", { 'active-slot': _ctx.isSelectedTime }]),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('onTimeSelect', _ctx.time)))
    }, [
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "slot-icon" }, null, -1)),
      _createElementVNode("div", _hoisted_2, [
        _createTextVNode(_toDisplayString(_ctx.timeStr[0]), 1),
        _createElementVNode("span", null, _toDisplayString(_ctx.timeStr[1]), 1)
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["slot-avail flex-col", { full: _ctx.totalAvailable == 0 }])
      }, [
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.timeStatus), 1),
        _withDirectives(_createElementVNode("span", null, _toDisplayString(_ctx.largeGroupAssignment), 513), [
          [_vShow, _ctx.assignedToSlot]
        ])
      ], 2),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("span", null, _toDisplayString(_ctx.time.Description), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_si_currency, { amount: _ctx.timePrice }, null, 8, ["amount"])
      ])
    ], 2)
  ]))
}